import { Box } from '@mui/material';
import { H2, P2M, Toolbar } from 'src/components';
import { themeColors } from 'src/theme';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import InvalidUsersTable from './InvalidUsersTable';

type Props = {
  invalidUsers: any[];
  errors: Record<string, string[]>;
  viewType: 'errors' | 'table';
  onViewTypeChange: (type: 'errors' | 'table') => void;
};

const ErrorReport = ({ invalidUsers, errors, viewType, onViewTypeChange }: Props) => {
  if (invalidUsers.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <H2>Report</H2>
        {viewType === 'table' && <Toolbar options={{ quickFilter: true }} />}
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
          <ViewListOutlinedIcon
            sx={{
              color: viewType === 'errors' ? themeColors.grayDark : themeColors.grayDisabled,
              mr: 1,
              cursor: 'pointer',
              '&:hover': { color: themeColors.yellowMain },
            }}
            onClick={() => onViewTypeChange('errors')}
          />
          <ViewModuleOutlinedIcon
            sx={{
              color: viewType === 'table' ? themeColors.grayDark : themeColors.grayDisabled,
              cursor: 'pointer',
              '&:hover': { color: themeColors.yellowMain },
            }}
            onClick={() => onViewTypeChange('table')}
          />
        </Box>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
        {viewType === 'errors' ? (
          <Box sx={{ border: `1px solid ${themeColors.grayMedium}`, mb: 8 }}>
            {Object.entries(errors).map(([row, errs]: [string, string[]]) => (
              <Box
                key={row}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: `1px solid ${themeColors.grayMedium}`,
                  '&:last-child': { borderBottom: 'none' },
                }}
              >
                <Box sx={{ minWidth: 60, color: themeColors.red, p: 1, borderRight: `1px solid ${themeColors.grayMedium}` }}>
                  <P2M>{`Row ${row}`}</P2M>
                </Box>
                <Box sx={{ color: themeColors.red, p: 1 }}>
                  <P2M component="span">{errs.join(', ')}</P2M>
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <InvalidUsersTable invalidUsers={invalidUsers} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ErrorReport;
